<template>
    <div>
        <b-row>
            <template v-if="deviceList !== undefined && JSON.stringify(deviceList) !== '{}'">
                <VirtualDeviceItem v-for="device in deviceList" v-bind:key="device.id" v-bind:device='device'>
                </VirtualDeviceItem>
            </template>
            <b-col v-else-if="!showingBottomNav" sm="6" lg="3">
                <b-card no-body class="bg-primary modules-container">
                    <b-card-body class="pb-0">
                        <h4 class="mb-0">No devices added</h4>
                        <p class="my-3">You have not added any devices. Please click the red floating button on
                            the right bottom corner of the screen to add a new device.
                        </p>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col v-if="showingBottomNav" sm="6" lg="3">
                <b-card class="bg-primary"
                        style="border: none; border-radius: 8px; box-shadow: 0px 10px 20px rgba(0, 0, 0, .18) !important; min-height: 202px;"
                        body-class="cardBody">
                    <div class="mt-3 mb-0">
                        <h4 align="center" class="mb-4"> Add a new device </h4>
                        <div class="text-center">
                            <i @click="showAddDeviceModal" class="fa fa-plus-circle plus-icon"></i>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <AddDeviceModal></AddDeviceModal>

        <LinkingOptionsModal></LinkingOptionsModal>

        <LinkByPasscodeModal></LinkByPasscodeModal>

        <UnlinkDeviceModal></UnlinkDeviceModal>

        <DeleteDeviceModal></DeleteDeviceModal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import VirtualDeviceItem from "./VirtualDeviceItem";
    import AddDeviceModal from "@/components/virtual-device/AddDeviceModal";
    import LinkingOptionsModal from "@/components/virtual-device/LinkingOptionsModal";
    import LinkByPasscodeModal from "@/components/virtual-device/LinkByPasscodeModal";
    import UnlinkDeviceModal from "@/components/virtual-device/UnlinkDeviceModal";
    import DeleteDeviceModal from "@/components/virtual-device/DeleteDeviceModal";
    import {isMobileNavigationMode} from "@/utilities/mobile.navigation.utility";

    export default {
        name: "VirtualDeviceList",

        components: {
            VirtualDeviceItem,
            AddDeviceModal,
            LinkingOptionsModal,
            LinkByPasscodeModal,
            UnlinkDeviceModal,
            DeleteDeviceModal
        },

        created() {
            this.$root.$on('added-device', this.addedDevice);
            this.$root.$on('deleted-device', this.deletedDevice);
            this.$root.$on('linked-device', this.linkedDevice);
            this.$root.$on('unlinked-device', this.unlinkedDevice);
            this.$root.$on('send-link-request', this.sendLinkRequest);
        },

        destroyed() {
            this.$root.$off('added-device');
            this.$root.$off('deleted-device');
            this.$root.$off('linked-device');
            this.$root.$off('unlinked-device');
            this.$root.$off('send-link-request');
        },

        computed: {
            ...mapGetters({
                deviceList: 'virtualDevice/deviceList',
            }),

            showingBottomNav: function () {
                return isMobileNavigationMode(this.$platform);
            }
        },

        methods: {
            showAddDeviceModal() {
                this.$root.$emit('bv::show::modal', 'addDeviceModal');
            },

            addedDevice(device) {
                this.$store.commit('virtualDevice/addDevice', device);
            },

            deletedDevice(id) {
                this.$store.commit('virtualDevice/deleteDevice', id);
            },

            linkedDevice(id, mac_address) {
                this.$store.commit('virtualDevice/linkDevice', {id: id, macAddress: mac_address});
            },

            unlinkedDevice(id) {
                this.$store.commit('virtualDevice/unlinkDevice', id);
            },

            sendLinkRequest(deviceId, passcode) {
                this.$axios({
                    method: 'put',
                    url: '/link-device',
                    params: {
                        'id': deviceId,
                        'passcode': passcode
                    },
                    timeout: 10000
                }).then(response => {
                    this.$root.$emit('showInfo', "Your device was linked successfully");
                    this.$root.$emit('bv::show::modal', 'info-modal');
                    this.$root.$emit('linked-device', response.data.id, response.data.mac_address);
                }).catch((err) => {
                    if (err.response) {
                        let error = err.response.data;
                        if (error.type) {
                            if (error.type === "ValidationError") {
                                this.$root.$emit('showError', this.$format(error.body.passcode));
                            } else if (error.type === "DemoAccountError" || error.type === 'LinkingError') {
                                this.$root.$emit('showError', error.body);
                            }
                        } else {
                            this.$root.$emit('showError', 'Could not link device.');
                        }
                    } else {
                        this.$root.$emit('showError', 'Timeout, the device did not respond.');
                    }
                    this.$root.$emit('bv::show::modal', 'error-modal');
                }).finally(() => {
                    this.passcode = "";
                });
            }
        }
    }
</script>

<style scoped>
    .plus-icon {
        font-size: 4.5rem;
    }

    .plus-icon:hover {
        cursor: pointer;
    }
</style>
